import * as React from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Video} from '@models/video-file'
import {deleteRequest, fetchRequest} from '@actions/video-file'
import VideosTable from "@components/video-files/Table";
import TableRenderer from "@hocs/TableRenderer";
import {getVideoFilesList} from "@reducers/videoFile";
import VideoFileForm from "@components/video-files/Form";
import {Button, Card} from "antd";
import {FormattedMessage} from 'react-intl';
import SearchVideoFilesComponent from "@components/video-files/Search";
import {NavLink} from "react-router-dom";


interface PropsFromState {
  loading: boolean
  data: Video[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class VideoFilesIndexPage extends React.Component<AllProps> {
  
  deleteVideo = (item: Video): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    })
  };
  
  render() {
    const {loading, data, currentPage, search} = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/video-files/create`}>
            <Button type={'primary'}>
              <FormattedMessage
                id="app.create_new_video_file"
                defaultMessage={`Create Video File`}/>
            </Button>
          </NavLink>
        </div>
        <div className={'page-table-wrapper'}>
          <Card className={`page-table-header search-part`} bordered={false}>
            <SearchVideoFilesComponent search={search}/>
          </Card>
          <VideosTable data={data}
                       currentPage={currentPage}
                       rowKey={record => record.id}
                       deleteFn={this.deleteVideo}
                       loading={loading}/>
        </div>
      
      </div>
    )
  }
}

const mapStateToProps = ({videoFiles}: ApplicationState) => ({
  loading: videoFiles.loading,
  data: getVideoFilesList(videoFiles),
  count: videoFiles.count,
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRenderer(VideoFilesIndexPage));

